export default "__VITE_ASSET__44e71557__"